import { ClientConstants } from 'finhelper';

export const isManager = (data) => {
  return data && data.role && ClientConstants.MANAGER_GROUP.indexOf(data.role) !== -1;
};
